import {
	Component,
	OnInit,
	Input,
	Optional,
	Inject,
	NgZone,
	ViewChild
} from "@angular/core";
import { FromFieldControl } from "../form-field-control";
import { FormGroupDirective } from "@angular/forms";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { take } from "rxjs/operators";

@Component({
    selector: "tc-text-area-form-field",
    templateUrl: "./text-area-form-field.component.html",
    styleUrls: ["./text-area-form-field.component.scss"],
    standalone: false
})
export class TextAreaFormFieldComponent extends FromFieldControl
	implements OnInit {
	@Input() minRows = 3;
	@Input() maxRows = 15;
	@Input() cols: number;

	@ViewChild("autosize", { static: true }) autosize: CdkTextareaAutosize;

	constructor(
		private ngZone: NgZone,
		@Optional()
		@Inject(FormGroupDirective)
		__formGroupDirective: FormGroupDirective
	) {
		super(__formGroupDirective);
	}

	triggerResize() {
		// Wait for changes to be applied, then trigger textarea resize.
		this.ngZone.onStable
			.pipe(take(1))
			.subscribe(() => this.autosize.resizeToFitContent(true));
	}

	ngOnInit() {}
}
